// 9:16 phone frame for Instagram reels (Hotel-Edition B2, PLAN.md §7.4). Two modes:
//   - preview (cards): the poster with a play badge, no <video> element at all, so a page of reels loads no video
//   - player (detail): <video playsInline controls preload="none" poster>, served by the Range-capable /objects
//     route, so iPhone Safari can seek. The video is only requested once the customer presses play.
import { Play, Clapperboard } from "lucide-react"

export function ReelPhoneFrame({
  posterUrl, videoUrl, title, mode, className = "",
}: {
  posterUrl?: string | null
  videoUrl?: string | null
  title?: string | null
  mode: "preview" | "player"
  className?: string
}) {
  return (
    <div
      className={`relative mx-auto aspect-[9/16] w-full rounded-[2rem] border-[6px] border-neutral-900 bg-neutral-900 shadow-lg overflow-hidden ${className}`}
      data-testid={`reel-frame-${mode}`}
    >
      {/* speaker notch */}
      <div className="absolute top-1.5 left-1/2 -translate-x-1/2 h-1.5 w-12 rounded-full bg-neutral-700 z-10" aria-hidden />
      {mode === "player" && videoUrl ? (
        <video
          src={videoUrl}
          poster={posterUrl ?? undefined}
          controls
          playsInline
          preload="none"
          className="h-full w-full object-cover bg-black"
          data-testid="reel-video"
        >
          Ihr Browser kann dieses Video nicht abspielen.
        </video>
      ) : (
        <>
          {posterUrl ? (
            <img src={posterUrl} alt={title || "Vorschaubild des Reels"} className="h-full w-full object-cover" loading="lazy" />
          ) : (
            <div className="h-full w-full flex flex-col items-center justify-end pb-6 gap-1 text-neutral-400 text-xs">
              <Clapperboard className="h-5 w-5" />
              Kein Vorschaubild
            </div>
          )}
          {videoUrl && (
            <div className="absolute inset-0 flex items-center justify-center" aria-hidden>
              <span className="rounded-full bg-black/55 p-3">
                <Play className="h-6 w-6 text-white fill-white" />
              </span>
            </div>
          )}
        </>
      )}
    </div>
  )
}
